/**
 * ============================================
 * BIGTIME STAFFELPREIS CHECKOUT
 * Version: 2.7
 * Letzte Änderung: 2026-02-02
 * ============================================
 * 
 * CHANGELOG:
 * v2.7 - NEU: Sendet verschlüsselte Varianten-ID (_enc) statt price
 *      - Backend entschlüsselt und holt Preis direkt von Shopify
 *      - Kein basispreis_staffelpreise Metafeld mehr nötig
 *      - Sicherer: Varianten-ID kann nicht manipuliert werden
 * v2.6 - Sendet price pro Item für Varianten-spezifische Rabattberechnung
 * v2.5 - Fix: Reset isProcessingCheckout bei Back-Button/Seitenwechsel
 * v2.4 - SECURE: Sendet nur Handle+Quantity, Backend validiert Preise
 * 
 * WICHTIG: Bei Änderungen immer Version oben aktualisieren!
 * ============================================
 */
(function() {
  'use strict';
  
  var API_URL = 'https://bigtime-veredelung-app-production.up.railway.app/api/discount/staffelpreis';
  var isProcessingCheckout = false;
  var lastAnalysis = null;
  var lastCartHash = '';
  var initialized = false;
  
  console.log('📦 Bigtime Checkout v2.7 geladen (verschlüsselte Varianten-ID)');
  
  // ============================================
  // FIX v2.5: Reset wenn Seite aus Cache geladen wird (Back-Button)
  // ============================================
  window.addEventListener('pageshow', function(event) {
    if (event.persisted || performance.getEntriesByType('navigation')[0]?.type === 'back_forward') {
      console.log('🔄 Seite aus Cache/Back-Button - Reset Processing State');
      isProcessingCheckout = false;
      lastCartHash = '';
      loadCartAndAnalyze(true);
    }
  });
  
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'visible') {
      console.log('🔄 Tab wieder aktiv - Reset Processing State');
      isProcessingCheckout = false;
    }
  });
  
  // ============================================
  // STAFFELPREIS-FUNKTIONEN (für Frontend-Anzeige)
  // ============================================
  
  function parseStaffelpreise(staffelString) {
    if (!staffelString || typeof staffelString !== 'string') return [];
    
    var staffeln = [];
    var parts = staffelString.split(';');
    
    parts.forEach(function(part) {
      var trimmed = part.trim();
      if (!trimmed) return;
      
      var split = trimmed.split(':');
      var range = split[0];
      var preisStr = split[1];
      if (!range || !preisStr) return;
      
      var preis = parseFloat(preisStr.trim().replace(',', '.'));
      if (isNaN(preis)) return;
      
      if (range.indexOf('-') > -1) {
        var rangeParts = range.split('-');
        var von = parseInt(rangeParts[0].trim());
        var bis = parseInt(rangeParts[1].trim());
        if (!isNaN(von) && !isNaN(bis)) {
          staffeln.push({ von: von, bis: bis, preis: preis });
        }
      } else {
        var vonOnly = parseInt(range.trim());
        if (!isNaN(vonOnly)) {
          staffeln.push({ von: vonOnly, bis: Infinity, preis: preis });
        }
      }
    });
    
    return staffeln;
  }
  
  function getStaffelpreis(staffeln, menge) {
    if (!staffeln || staffeln.length === 0) return null;
    
    for (var i = 0; i < staffeln.length; i++) {
      var s = staffeln[i];
      if (menge >= s.von && (s.bis === Infinity || menge <= s.bis)) {
        return s.preis;
      }
    }
    
    return staffeln[0].preis;
  }
  
  function getCartHash(cart) {
    var hash = '';
    cart.items.forEach(function(item) {
      hash += item.handle + ':' + item.quantity + ':' + item.price + ';';
    });
    return hash;
  }
  
  // ============================================
  // WARENKORB ANALYSIEREN
  // v2.7: Sammelt _enc (verschlüsselte Varianten-ID)
  // ============================================
  
  function analyzeCart(cart) {
    var staffelItems = [];
    var handleQuantities = {};
    
    cart.items.forEach(function(item) {
      var staffelConfig = null;
      var encryptedVariantId = null;
      var originalPrice = null;
      
      if (item.properties) {
        if (item.properties._staffelpreise) {
          staffelConfig = item.properties._staffelpreise;
        }
        // v2.7: Verschlüsselte Varianten-ID
        if (item.properties._enc) {
          encryptedVariantId = item.properties._enc;
        }
        // Fallback für alte Items ohne _enc
        if (item.properties._staffelpreis_originalpreis) {
          originalPrice = parseFloat(item.properties._staffelpreis_originalpreis);
        }
      }
      
      if (staffelConfig) {
        var handle = item.handle || item.product_id;
        var price = originalPrice || (item.price / 100);
        
        staffelItems.push({
          productHandle: handle,
          title: item.product_title,
          variantTitle: item.variant_title || '',
          quantity: item.quantity,
          price: price,
          enc: encryptedVariantId,  // v2.7: Verschlüsselte ID
          staffelConfig: staffelConfig
        });
        
        if (!handleQuantities[handle]) {
          handleQuantities[handle] = {
            totalQuantity: 0,
            staffelConfig: staffelConfig
          };
        }
        handleQuantities[handle].totalQuantity += item.quantity;
      }
    });
    
    // Rabatt für Frontend-Anzeige berechnen
    var totalDiscount = 0;
    var discountDetails = [];
    
    staffelItems.forEach(function(item) {
      var handleData = handleQuantities[item.productHandle];
      var staffeln = parseStaffelpreise(item.staffelConfig);
      var staffelpreis = getStaffelpreis(staffeln, handleData.totalQuantity);
      
      if (staffelpreis !== null && item.price > 0) {
        var discountPerItem = item.price - staffelpreis;
        
        if (discountPerItem > 0) {
          var itemDiscount = discountPerItem * item.quantity;
          totalDiscount += itemDiscount;
          
          discountDetails.push({
            productHandle: item.productHandle,
            title: item.title,
            variantTitle: item.variantTitle,
            quantity: item.quantity,
            price: item.price,
            enc: item.enc,
            staffelpreis: staffelpreis,
            discountPerItem: discountPerItem,
            totalDiscount: itemDiscount
          });
        }
      }
    });
    
    return {
      hasDiscount: totalDiscount > 0,
      totalDiscount: Math.round(totalDiscount * 100) / 100,
      details: discountDetails,
      hasStaffelProducts: staffelItems.length > 0
    };
  }
  
  // ============================================
  // HINWEIS-ANZEIGE
  // ============================================
  
  function createHintElement(analysis) {
    var discountText = analysis.totalDiscount.toFixed(2).replace('.', ',');
    var hintHTML = '';
    
    if (analysis.hasDiscount) {
      hintHTML = '<div style="display: flex; align-items: center; gap: 10px;">' +
        '<span style="font-size: 20px;">🎉</span>' +
        '<div>' +
          '<strong style="color: #0d9488;">Mengenrabatt aktiv!</strong><br>' +
          '<span style="color: #374151;">Du sparst ca. <strong>' + discountText + ' €</strong> - wird im Checkout angewendet.</span>' +
        '</div>' +
      '</div>';
    } else if (analysis.hasStaffelProducts) {
      hintHTML = '<div style="display: flex; align-items: center; gap: 10px;">' +
        '<span style="font-size: 20px;">💡</span>' +
        '<div>' +
          '<strong style="color: #0d9488;">Mengenrabatt möglich!</strong><br>' +
          '<span style="color: #374151;">Bestelle mehr und spare mit unseren Staffelpreisen.</span>' +
        '</div>' +
      '</div>';
    }
    
    return hintHTML;
  }
  
  function showDiscountHintOnCartPage(analysis) {
    if (window.location.pathname !== '/cart') return;
    
    var existingHint = document.getElementById('bigtime-staffel-hint');
    
    if (!analysis.hasStaffelProducts) {
      if (existingHint) existingHint.remove();
      return;
    }
    
    var hintHTML = createHintElement(analysis);
    
    if (existingHint) {
      existingHint.innerHTML = hintHTML;
      console.log('🔄 Cart-Hinweis aktualisiert');
    } else {
      var hint = document.createElement('div');
      hint.id = 'bigtime-staffel-hint';
      hint.style.cssText = 'background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%); border: 1px solid #0d9488; border-radius: 8px; padding: 12px 16px; margin: 15px 0; font-size: 14px;';
      hint.innerHTML = hintHTML;
      
      var insertTarget = document.querySelector('.cart__items') ||
                         document.querySelector('form[action="/cart"]') || 
                         document.querySelector('.cart') ||
                         document.querySelector('[data-cart]') ||
                         document.querySelector('main');
      
      if (insertTarget) {
        insertTarget.parentNode.insertBefore(hint, insertTarget);
        console.log('✅ Cart-Hinweis eingefügt');
      }
    }
  }
  
  function showDiscountHintInDrawer(analysis) {
    var drawerSelectors = [
      '.cart-drawer', '.drawer--cart', '.mini-cart', '.cart-sidebar',
      '.cart-flyout', '.cart-modal', '[data-cart-drawer]', '[data-mini-cart]',
      '.side-cart', '.ajax-cart', '.cart-overlay', '#cart-drawer',
      '#mini-cart', '#CartDrawer', '.cart-drawer__inner', '.drawer__inner'
    ];
    
    var drawer = null;
    for (var i = 0; i < drawerSelectors.length; i++) {
      drawer = document.querySelector(drawerSelectors[i]);
      if (drawer) break;
    }
    
    if (!drawer) return;
    
    var existingHint = drawer.querySelector('#bigtime-staffel-hint-drawer');
    
    if (!analysis.hasStaffelProducts) {
      if (existingHint) existingHint.remove();
      return;
    }
    
    var hintHTML = createHintElement(analysis);
    
    if (existingHint) {
      existingHint.innerHTML = hintHTML;
      console.log('🔄 Drawer-Hinweis aktualisiert');
    } else {
      var hint = document.createElement('div');
      hint.id = 'bigtime-staffel-hint-drawer';
      hint.style.cssText = 'background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%); border: 1px solid #0d9488; border-radius: 8px; padding: 12px 16px; margin: 10px; font-size: 13px;';
      hint.innerHTML = hintHTML;
      
      var insertPositions = [
        drawer.querySelector('.cart-drawer__footer'),
        drawer.querySelector('.drawer__footer'),
        drawer.querySelector('.mini-cart__footer'),
        drawer.querySelector('[data-cart-footer]'),
        drawer.querySelector('.cart-drawer__items'),
        drawer.querySelector('.drawer__body'),
        drawer
      ];
      
      for (var j = 0; j < insertPositions.length; j++) {
        var pos = insertPositions[j];
        if (pos) {
          if (pos === drawer) {
            pos.insertBefore(hint, pos.firstChild);
          } else {
            pos.parentNode.insertBefore(hint, pos);
          }
          console.log('✅ Drawer-Hinweis eingefügt');
          break;
        }
      }
    }
  }
  
  function showDiscountHint(analysis) {
    showDiscountHintOnCartPage(analysis);
    showDiscountHintInDrawer(analysis);
  }
  
  // ============================================
  // CHECKOUT HANDLER
  // v2.7: Sendet enc (verschlüsselte Varianten-ID)
  // ============================================
  
  function handleCheckout(e) {
    if (isProcessingCheckout) {
      console.log('⏳ Checkout wird bereits verarbeitet, überspringe...');
      return;
    }
    
    if (!lastAnalysis || !lastAnalysis.hasDiscount) {
      console.log('ℹ️ Kein Rabatt, normaler Checkout');
      return;
    }
    
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    isProcessingCheckout = true;
    
    var btn = e.currentTarget || e.target;
    
    btn.disabled = true;
    btn.style.opacity = '0.6';
    btn.style.pointerEvents = 'none';
    
    if (btn.tagName === 'INPUT') {
      btn.value = 'Rabatt wird angewendet...';
    } else {
      btn.textContent = 'Rabatt wird angewendet...';
    }
    
    // ============================================
    // v2.7: Items mit verschlüsselter Varianten-ID senden
    // ============================================
    var secureItems = lastAnalysis.details.map(function(item) {
      return {
        productHandle: item.productHandle,
        quantity: item.quantity,
        enc: item.enc || null  // v2.7: Verschlüsselte Varianten-ID
      };
    });
    
    var oldCode = sessionStorage.getItem('bigtime_last_discount_code');
    
    var requestData = {
      items: secureItems,
      oldCode: oldCode
    };
    
    console.log('📤 Sende Discount-Anfrage v2.7:', requestData);
    
    fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestData)
    })
    .then(function(res) { return res.json(); })
    .then(function(result) {
      console.log('📥 Discount-Antwort:', result);
      
      if (result.success && result.code) {
        sessionStorage.setItem('bigtime_last_discount_code', result.code);
        console.log('✅ Discount Code:', result.code, '- Rabatt:', result.totalDiscount + '€');
        isProcessingCheckout = false;
        window.location.href = '/checkout?discount=' + result.code;
      } else {
        console.log('ℹ️ Kein Discount erstellt, normaler Checkout');
        isProcessingCheckout = false;
        window.location.href = '/checkout';
      }
    })
    .catch(function(err) {
      console.error('❌ Discount Fehler:', err);
      isProcessingCheckout = false;
      window.location.href = '/checkout';
    });
  }
  
  // ============================================
  // EVENT LISTENERS
  // ============================================
  
  function setupCheckoutListeners() {
    var selectors = [
      '[name="checkout"]', 'button[name="checkout"]', 'input[name="checkout"]',
      '.cart__checkout-button', '.cart__checkout', '.cart-drawer__checkout',
      '.mini-cart__checkout', '.drawer__checkout', 'a[href="/checkout"]',
      'a[href*="/checkout"]', '[data-action="checkout"]', '[data-checkout]',
      '.checkout-button', '#checkout-button'
    ];
    
    selectors.forEach(function(selector) {
      document.querySelectorAll(selector).forEach(function(btn) {
        if (btn.hasAttribute('data-bigtime-checkout')) return;
        btn.setAttribute('data-bigtime-checkout', 'true');
        
        btn.addEventListener('click', handleCheckout, true);
        console.log('✅ Checkout-Listener:', btn.tagName, btn.name || btn.className || '');
      });
    });
  }
  
  // ============================================
  // WARENKORB LADEN UND ANALYSIEREN
  // ============================================
  
  function loadCartAndAnalyze(force) {
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var newHash = getCartHash(cart);
        
        if (!force && newHash === lastCartHash) {
          return;
        }
        
        lastCartHash = newHash;
        console.log('🛒 Warenkorb geladen:', cart.item_count, 'Artikel');
        
        var analysis = analyzeCart(cart);
        lastAnalysis = analysis;
        console.log('📊 Staffelpreis-Analyse v2.7:', analysis);
        
        showDiscountHint(analysis);
        setupCheckoutListeners();
      })
      .catch(function(err) {
        console.error('❌ Warenkorb-Fehler:', err);
      });
  }
  
  // ============================================
  // POLLING & OBSERVER
  // ============================================
  
  var pollInterval = null;
  
  function startPolling() {
    pollInterval = setInterval(function() {
      loadCartAndAnalyze(false);
    }, 1500);
  }
  
  function stopPolling() {
    if (pollInterval) {
      clearInterval(pollInterval);
      pollInterval = null;
    }
  }
  
  var debounceTimer = null;
  
  function triggerReload() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() {
      loadCartAndAnalyze(true);
    }, 300);
  }
  
  function watchForDrawer() {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' || mutation.type === 'childList') {
          var drawerSelectors = ['.cart-drawer', '.drawer--cart', '.mini-cart', '[data-cart-drawer]', '.side-cart', '#CartDrawer'];
          for (var i = 0; i < drawerSelectors.length; i++) {
            var drawer = document.querySelector(drawerSelectors[i]);
            if (drawer) {
              var isVisible = drawer.classList.contains('is-open') || 
                              drawer.classList.contains('active') || 
                              drawer.classList.contains('is-active') ||
                              drawer.classList.contains('open') ||
                              drawer.getAttribute('aria-hidden') === 'false' ||
                              window.getComputedStyle(drawer).display !== 'none';
              
              if (isVisible) {
                console.log('🛒 Drawer Cart erkannt');
                triggerReload();
                break;
              }
            }
          }
        }
      });
    });
    
    observer.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['class', 'aria-hidden', 'style']
    });
  }
  
  // ============================================
  // INITIALISIERUNG
  // ============================================
  
  function init() {
    if (initialized) return;
    initialized = true;
    
    loadCartAndAnalyze(true);
    startPolling();
    watchForDrawer();
    
    window.addEventListener('beforeunload', stopPolling);
    
    document.addEventListener('change', function(e) {
      var target = e.target;
      if (target.matches('input[name*="quantity"], input[name*="updates"], input[type="number"], select[name*="quantity"]')) {
        console.log('📝 Mengenänderung erkannt (change)');
        triggerReload();
      }
    });
    
    document.addEventListener('input', function(e) {
      var target = e.target;
      if (target.matches('input[name*="quantity"], input[name*="updates"], input[type="number"]')) {
        console.log('📝 Mengenänderung erkannt (input)');
        triggerReload();
      }
    });
    
    document.addEventListener('click', function(e) {
      var target = e.target.closest('[data-quantity-minus], [data-quantity-plus], .quantity-btn, .qty-btn, .js-qty-btn, button[aria-label*="quantity"], button[aria-label*="Quantity"], .cart-item__quantity-button, [data-decrease], [data-increase], .quantity__button');
      if (target) {
        console.log('📝 Quantity-Button geklickt');
        triggerReload();
      }
    });
    
    var originalFetch = window.fetch;
    window.fetch = function() {
      var url = arguments[0];
      if (typeof url === 'string' && (url.indexOf('/cart/change') > -1 || url.indexOf('/cart/update') > -1 || url.indexOf('/cart/add') > -1)) {
        console.log('📝 Cart-AJAX erkannt:', url);
        setTimeout(triggerReload, 500);
      }
      return originalFetch.apply(this, arguments);
    };
    
    var originalXHROpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function() {
      var url = arguments[1];
      if (typeof url === 'string' && (url.indexOf('/cart/change') > -1 || url.indexOf('/cart/update') > -1 || url.indexOf('/cart/add') > -1)) {
        this.addEventListener('load', function() {
          console.log('📝 Cart-XHR erkannt:', url);
          setTimeout(triggerReload, 500);
        });
      }
      return originalXHROpen.apply(this, arguments);
    };
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();
